// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__thqNL","floatingLabel":"Label_floatingLabel__yUypX","floatingLabelText":"Label_floatingLabelText__2OXvG","focused":"Label_focused__z5CS5"};